/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentTrackerOrderNavigation: "shipment-tracker-order-navigation",
  shipmentTrackerOrderView: "shipment-tracker-order-view",
  shipmentTrackerEvents: "shipment-tracker-events",
} as const;
